import React from 'react';
import { LinkProps } from 'react-router-dom';
import Hyperlink from './hyperlink';
import { RouterHyperlinkSC } from './hyperlink.styled';
import { THyperlinkVariant } from './hyperlink.types';

interface RouterHyperlinkProps<S = unknown> extends LinkProps<S> {
  variant?: THyperlinkVariant;
}

const RouterHyperlink = (props: RouterHyperlinkProps, ref?: React.Ref<HTMLAnchorElement>) => {
  const { variant, children, ...rest } = props;

  return (
    <RouterHyperlinkSC ref={ref} {...rest}>
      {children}
    </RouterHyperlinkSC>
  );
};

export default React.forwardRef(RouterHyperlink);
